import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import OnCallairAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/OnCallairAppIcon';

import OnCallAirDialog from '../Dialogs/OnCallAirDialog';

const OnlineBookingStrategy = {
  previewInfo: {
    name: 'OnCall Air',
    iconSvg: <OnCallairAppIcon size="xlarge" />,
    newTab: true,
  },
  headerInfo: {
    name: 'Profesional proposals for the HVAC industry',
    category: 'Create HVAC Sales Proposals',
    details:
      "Housecall Pro has partnered with OnCall Air to provide HVAC companies with the industy's leading sales proposal tool.",
    iconSvg: <OnCallairAppIcon size="xlarge" />,
  },
  media: {
    videoUrl: '',
  },
  sellingPoints: {
    headline: 'Why use OnCall Air?',
    description:
      'If you use OnCall Air, this app will allow you to send customer data directly over to OnCall Air where you can create your favorite HVAC sales proposals. When one of you customers accepts a proposal OnCall Air will send that proposal back to Housecall Pro as job where you can schedule it and complete it like any other job in Housecall Pro.',
  },
  planAvailability: {
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  price: {
    title: 'Partner Pricing',
    description: (
      <div>
        <Grid container spacing={8}>
          <Grid item>
            <Typography align="left">
              <a href="https://www.oncallair.com/pricing" target="_blank" rel="noreferrer">
                https://www.oncallair.com/pricing
              </a>
            </Typography>
          </Grid>
          <Grid item>
            <Typography align="center" color="textSecondary">
              To use the integration, you must have an account with OnCall Air. Plans start at $99/month
            </Typography>
          </Grid>
        </Grid>
      </div>
    ),
    disclaimer: 'Enabling this toggle will share your contact information with the partner',
  },
  supportContacts: [
    { type: 'Phone', contact: '888-808-6231' },
    {
      type: 'Website',
      contact: (
        <div>
          <a href="https://www.oncallair.com" target="_blank" rel="noreferrer">
            OnCall Air website
          </a>
        </div>
      ),
    },
  ],
  dialog: <OnCallAirDialog />,
};

export default OnlineBookingStrategy;
